import $ from 'jquery';

let gmap = null;
const gmapPromise = $.Deferred();

function setMap(map) {
    gmap = map;
}
function getMap() {
    return gmap;
}
function mapPromise() {
    const prom = $.Deferred();
    gmapPromise.then(() => {
        prom.resolve(gmap);
    });
    return prom;
}
function resolveMapPromise() {
    gmapPromise.resolve();
}

function createLatLangObjectFromString(lat, lng) {
    let latLngTemplate = function (a, b) {
        a -= 0;
        b -= 0;

        const latRegex = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
        const lngRegex = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
        a = latRegex.test(a) ? a : false;
        b = lngRegex.test(b) ? b : false;
        this.lat = function () {
            return a;
        };
        this.lng = function () {
            return b;
        };
    };

    return new latLngTemplate(lat, lng);
}

export { setMap, getMap, mapPromise, createLatLangObjectFromString, resolveMapPromise };
